<template>
  <div>
    <div class="downLoadPane">
      <div class="list">
        <ul>
          <li v-for="item in downLaodLists" :key="item.index" @click="download(item)"
            style="text-decoration: underline;">
            {{ item.name }}
            <img src="@/assets/download.png" />
          </li>
        </ul>
        <div class="downloadIcon">下载</div>
      </div>
    </div>
  </div>
</template>

<script>
import xybAgent from '@xybplugins/xyb-agent'
export default {
  name: "downLoadPane",
  data() {
    return {
      tdtBaseUrl: "https://hunan.tianditu.gov.cn",
      xybBaseUrl: "https://zw.zrzyt.hunan.gov.cn",
      downLaodLists: [
      
      ],
    };
  },
  methods: {
    download(item) {

      const hash = window.location.hash;
      const queryString = hash.substring(hash.indexOf('?') + 1);
      const params = new URLSearchParams(queryString);
      if (params.get('from') == 'zrzy_qjd') {
        // 湘易办
        const dataInfo = {
          url: this.xybBaseUrl + item.link,
          name: item.link.split('images/')[1]
        };
        xybAgent.fileDownload(dataInfo).then(res => {
          if (res.code == -1) {
            //不是湘易办app环境
            window.open(this.xybBaseUrl + item.link)
          }
        })
      } else {
        window.open(this.tdtBaseUrl + item.link)
      }


      // fetch(item.link)
      //   .then(response => response.blob())
      //   .then(blob => {
      //     // 创建对象URL
      //     const url = window.URL.createObjectURL(blob);
      //     // 创建隐藏的a标签并触发点击
      //     const a = document.createElement('a');
      //     a.style.display = 'none';
      //     a.href = url;
      //     a.download = '';
      //     // 添加到文档中
      //     document.body.appendChild(a);
      //     // 触发点击下载
      //     a.click();
      //     // 清理
      //     window.URL.revokeObjectURL(url);
      //     document.body.removeChild(a);
      //   })
      //   .catch(error => {
      //     console.error('下载失败:', error);
      //   });
    }
  },
  mounted() {
    this.downLaodLists = window.config.downLaodLists
  },
};
</script>

<style scoped lang="scss">
.downLoadPane {
  position: absolute;
  top: 50%;
  left: 0;
  z-index: 19999;
  transform: translateY(-50%);

  &:hover {
    .list {
      margin-left: 0;
    }
  }

  .list {
    transition: all 0.5s;
    width: 90px;
    position: relative;
    padding: 10px;
    background-color: #fff;
    box-shadow: 1px 1px 5px rgba(0, 0, 0, 0.3);
    margin-left: -110px;

    ul {
      padding: 0;
      margin: 0;
      list-style: none;
      line-height: 30px;
      img{
        width: 20px;
      }
    }

    .downloadIcon {
      padding: 10px 0;
      width: 30px;
      writing-mode: vertical-lr;
      line-height: 25px;
      position: absolute;
      top: 50%;
      right: -30px;
      z-index: 9999;
      transform: translateY(-50%);
      background-color: #e6a23c;
      color: #fff;
    }
  }
}
</style>